/** The operations served by the `adminProxy` HTTP router (T-252); the server `OPS` is this list. */
const ADMIN_OP_NAMES = [
  // functions/src/admin/workspaceAdmin.ts
  "adminGetAllWorkspaces",
  "adminGetWorkspaceDetail",
  "adminUpdateWorkspace",
  "adminBlockWorkspace",
  "adminUnblockWorkspace",
  "adminSoftDeleteWorkspace",
  "adminRestoreWorkspace",
  "adminAddWorkspaceCollaboratorDirect",
  "adminRemoveWorkspaceCollaborator",
  "adminGetWorkspaceCollaborators",
  "adminUpdateWorkspaceCollaboratorRole",
  "adminGetCollaboratorDetail",
  "adminUpdateCollaborator",
  "adminGetWorkspaceProjects",
  "adminGetWorkspaceTemplates",
  "adminAssignProjectTemplates",
  "adminGetProjectCollaborators",
  "adminAddProjectCollaboratorDirect",
  "adminUpdateProjectCollaborator",
  "adminRemoveProjectCollaborator",
  "adminGetProjectTemplates",
  "adminGetProjectTemplate",
  "adminGetShapeRecipes",
  "adminGetShapeRecipe",
  "adminValidateShapeRecipeCode",
  "adminCreateShapeRecipe",
  "adminUpdateShapeRecipe",
  "adminDeleteShapeRecipe",
  "adminGetShapeRecipeDraft",
  "adminGetShapeRecipeVersions",
  "adminGetShapeRecipeVersion",
  "adminPublishShapeRecipe",
  "adminActivateShapeRecipeVersion",
  "adminExtractDocumentStructure",
  "adminCreateProjectTemplate",
  "adminUpdateProjectTemplate",
  "adminDeleteProjectTemplate",
  "adminSetDefaultProjectTemplate",
  "adminDuplicateProjectTemplate",
  "adminGetProjectTemplateUsage",
  "adminAddWorkspaceToTemplate",
  "adminRemoveWorkspaceFromTemplate",
  "adminCreateWorkspace",
  "adminDeleteWorkspace",
  "adminGetAllUsers",
  "adminGetUserDetail",
  "adminUpdateUser",
  // functions/src/admin/boostAdmin.ts
  "adminGetWorkspaceBoostUsage",
  "adminGetCostsByWorkflow",
  "adminGetWorkspaceBoostTransactions",
  "adminGetAllWorkspacesBoostSummary",
  "adminGetWorkspaceActivity",
  "adminGrantBoosts",
  "adminGetWorkspaceContract",
  "adminUpdateWorkspaceContract",
  "adminGetPricingConfig",
  "adminGetCostsByOperation",
  // functions/src/admin/boostGateAdmin.ts
  "adminGetBoostGateConfig",
  "adminUpdateBoostGateConfig",
  // functions/src/admin/stripeAdmin.ts
  "adminListStripeProducts",
  "adminUpdateStripeProduct",
  "adminUpdateStripePrice",
  "adminCreateStripeProduct",
  "adminCreateStripePrice",
  // functions/src/admin/adminSettings.ts
  "adminGetSettings",
  "adminUpdateSettings",
  "adminGetAppSettings",
  "adminUpdateAppSetting",
  // functions/src/admin/adminInfrastructure.ts
  "adminGetInfrastructure",
  "adminRefreshInfrastructure",
  // functions/src/admin/sendWizardInvite.ts
  "sendWizardInvite",
  // functions/src/admin/adminApiKeys.ts
  "adminListApiKeys",
  "adminCreateApiKey",
  "adminRevokeApiKey",
  "adminUpdateApiKey",
  // functions/src/admin/userAdmin.ts
  "adminPurgeUser",
  "adminGetUserWorkspaces",
  // functions/src/admin/trialAdmin.ts
  "adminListTrials",
  "adminResetTrial",
  // functions/src/admin/workflowAdmin.ts
  "adminListWorkflows",
  "adminGetWorkspaceWorkflow",
  "adminSetWorkspaceWorkflow",
  // functions/src/naraWizard/proxy.ts
  "listWizardBlocks",
  "listWizardTemplates",
  "getWizardTemplate",
  "createWizardTemplate",
  "updateWizardTemplate",
  "createWizardInstance",
  "listWizardInstances",
  "getWizardInstanceDetail",
  "deleteWizardInstance",
  "bulkDeleteWizardInstances",
  // functions/src/naraChef/proxy.ts
  "getChefConfig",
  "updateChefConfig",
  // lib/recipeChef.ts: the Recipe Chef console (T-330 batch 8); chefListRecipes stays a member callable
  "chefChat",
  "listChefSessions",
  "getChefSession",
  "deleteChefSession",
  "chefGetRecipe",
  "renderHtmlPreview",
] as const;

export const ADMIN_OPS: ReadonlySet<string> = new Set(ADMIN_OP_NAMES);
